//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data: function data() {
        return {
            show: false,
            requireReason: false,
            reason: '',
            object: null,
            url: null,
            callback: null,
            message: 'Are you sure you want to delete that?',
            actionName: 'YES',
            loading: false,
            HttpVerb: ''
        };
    },
    mounted: function mounted() {

        var $el = this;

        /**
         * Opens confirm delete modal
         * @param  {object} object
         * @param  {string} url
         * @param  {string} callback         [string name of Event emit for callback function in other component]
         * @param  {string} message          [defaults to below]
         * @param  {string} actionName
         * @param  {string} reason
         * @return void
         */
        Event.$on('confirm-delete', function (object, url, callback, message, actionName, reason, HttpVerb) {
            $el.loading = false;
            $el.show = true;
            $el.object = object;
            $el.url = url;
            $el.callback = callback;
            $el.requireReason = reason;
            $el.HttpVerb = HttpVerb;

            if (message) {
                $el.message = message;
            } else {
                $el.message = "Are you sure you want to delete this?";
            }
            if (actionName) {
                $el.actionName = actionName;
            } else {
                $el.actionName = "DELETE";
            }
        });
    },
    created: function created() {
        var _this = this;

        //allows modal to be dismissed on escape key
        document.addEventListener('keydown', function (e) {
            if (e.key == 'Escape' && _this.show) {
                _this.show = false;
            }
        });
    },


    methods: {
        proceed: function proceed() {

            var $el = this;
            this.loading = true;
            if ($el.requireReason) {
                $el.object.reason = $el.reason;
            }
            if ($el.url != '') {
                if ($el.HttpVerb) {
                    axios.delete($el.url).then(function (response) {
                        if ($el.callback) {
                            Event.$emit($el.callback, $el.object, response);
                        }
                        $el.show = false;
                    });
                } else {
                    axios.post($el.url, $el.object).then(function (response) {
                        if ($el.callback) {
                            Event.$emit($el.callback, $el.object, response);
                        }
                        $el.show = false;
                    });
                }
            } else {
                if ($el.callback) {
                    Event.$emit($el.callback, $el.object);
                }
                $el.show = false;
            }
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"cacheDirectory":true,"presets":[["env",{"modules":false,"targets":{"browsers":["> 2%"],"uglify":true}}]],"plugins":["transform-object-rest-spread",["transform-runtime",{"polyfill":false,"helpers":false}]],"env":{"test":{"presets":[["env",{"targets":{"node":"current"}}]]},"development":{"presets":[["env",{"modules":false}]]},"production":{"presets":[["env",{"modules":false,"targets":{"browsers":"> 2%","uglify":true}}]]}}}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/layout/RemoveModal.vue
// module id = LBD0
// module chunks = 0 1